import moment from 'moment';
// 获取分组的时间
const getGroupTime = (time, isMin) => {
    if (isMin) {
        // 在抓拍时间上+10分钟作为组名，在整点时（10分）向上取整无效，显式+10
        const minute = Math.floor(Number(moment(time).format('mm')) / 10) * 10 + 10;
        return moment(time)
            .set({ minute, second: 0, millisecond: 0 })
            .valueOf();
    }
    else {
        return moment(time)
            .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
            .add(1, 'd')
            .valueOf();
    }
};
// 格式化时间标题
const formatTitle = (time, isMin) => {
    let format = '';
    if (isMin) {
        // 当天显示时分  非当天显示月-日 非当年的显示年-月-日
        if (moment(time).isSame(moment(), 'day')) {
            format = 'HH:mm';
        }
        else if (moment(time).isSame(moment(), 'y')) {
            format = 'MM-DD HH:mm';
        }
        else {
            format = 'yyyy-MM-DD HH:mm';
        }
    }
    else {
        // 按天统计，显示需要减一天
        time = time - 86400000;
        if (moment(time).isSame(moment(), 'y')) {
            format = 'MM-DD';
        }
        else {
            format = 'yyyy-MM-DD';
        }
    }
    return moment(time).format(format);
};
// 按日期排序
const insertionSort = (list) => {
    // 从第二个数开始往前比
    for (let i = 1; i < list.length; ++i) {
        // 先把值保存起来
        const temp = list[i];
        let j = i;
        while (j > 0) {
            if (new Date(list[j - 1].captureTime) < new Date(temp.captureTime)) {
                list[j] = list[j - 1];
            }
            else {
                // 因为已经是排序过的了，如果比上一位大，那就没必要再跟上上位比较了
                break;
            }
            j -= 1;
        }
        // 这里的j有可能是第0位，也有可能是到了一半停止了
        list[j] = temp;
    }
    return list;
};
// 按时间分组告警
export const formatSnapImageList = (snapImageList, groupDuration, isTimestamp) => {
    const group = [];
    let time;
    let children;
    const isMin = groupDuration < 1440;
    // TODO:后端无排序参数,暂时前端排序
    snapImageList = isTimestamp ? snapImageList : insertionSort(snapImageList);
    // 初始化
    if (snapImageList[0]) {
        // snapImageList[0].captureTime = 1655901012;
        const captureTime = isTimestamp ? snapImageList[0].captureTime * 1000 : moment(snapImageList[0].captureTime).valueOf();
        time = getGroupTime(captureTime, isMin);
        children = [];
        group.push({
            time: formatTitle(time, isMin),
            list: children,
        });
    }
    snapImageList.forEach(item => {
        const captureTime = isTimestamp ? snapImageList[0].captureTime * 1000 : moment(item.captureTime).valueOf();
        // 判断是否在当前时间分组内
        if (time > captureTime && time - captureTime <= groupDuration * 60000) {
            children.push(item);
        }
        else {
            const n = Math.floor((time - captureTime) / (groupDuration * 60000));
            time = time - n * (groupDuration * 60000);
            children = [item];
            group.push({
                time: formatTitle(time, isMin),
                list: children,
            });
        }
    });
    return group;
};
